export default __webpack_public_path__ + "static/media/cars_24_img.2b23e1a1.png";